var __webpack_error__ = new Error();
module.exports = new Promise(function(resolve, reject) {
	if(typeof messaging_extension !== "undefined") return resolve();
	__webpack_require__.l("https://dashboard-extensions.aircall.io/messaging-extension/messaging_extension.js", function(event) {
		if(typeof messaging_extension !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "messaging_extension");
}).then(function() { return messaging_extension; });